import {APP_ENV, SETTINGS_HOST} from '../../utils/constants';

type SettingsApiInitProps = {
  client: HttpClient;
  appEnv?: 'test' | 'stage' | 'prod';
  onLoadSettingsFailed?: (reason?: any) => undefined;
  onUnAuthorizedCallback?: () => undefined | void;
};

type SettingsInitData = {
  httpClient: HttpClient;
  settings: {[key: string]: string};
};

class SettingsApi {
  // --initPromise is used so get* properites will know to await the initialize call...
  private initPromiseResolve: (props: SettingsInitData) => void;

  private initPromiseFailed: (reason?: any) => void;

  private initPromise = new Promise<SettingsInitData>((resolve, failed) => {
    this.initPromiseResolve = resolve;
    this.initPromiseFailed = failed;
  });

  private async loadSettingsFile(props: SettingsApiInitProps) {
    const {client, appEnv = APP_ENV.stage} = props;
    const settingsHost = SETTINGS_HOST[appEnv];

    return client
      .request<{[key: string]: string}>({
        baseURL: settingsHost,
        url: `/settings.json`,
      })
      .then(
        (result) => {
          this.initPromiseResolve({httpClient: client, settings: result.data || {}});
        },
        (reason) => {
          this.initPromiseFailed(reason);
          throw reason;
        }
      );
  }

  private loadSettingsFilePromise: Promise<void>;

  init(props: SettingsApiInitProps) {
    const {onLoadSettingsFailed} = props;
    this.loadSettingsFilePromise =
      this.loadSettingsFilePromise === undefined ? this.loadSettingsFile(props) : this.loadSettingsFilePromise;
    this.loadSettingsFilePromise.then(
      () => {
        // success
      },
      (reason) => {
        if (onLoadSettingsFailed) {
          onLoadSettingsFailed(reason);
        }
      }
    );
  }

  getPaymentUrl = async () => {
    return this.initPromise.then((data) => data.settings.paymentApiBaseUrl || '');
  };

  getWalletUrl = async () => {
    return this.initPromise.then((data) => data.settings.walletBaseUrl || '');
  };

  getCustomerUrl = async () => {
    return this.initPromise.then((data) => data.settings.customerApiBaseUrl || '');
  };

  getApiURL = async ({api}: {api: 'CUSTOMER' | 'PAYMENT' | 'WALLET'}) => {
    return this.initPromise.then((data) => {
      switch (api) {
        case 'CUSTOMER':
          return data.settings.customerApiBaseUrl || '';
        case 'PAYMENT':
          return data.settings.paymentApiBaseUrl || '';
        case 'WALLET':
          return data.settings.walletBaseUrl || '';
        default:
          return '';
      }
    });
  };

  getUpstreamEnv = async () => {
    return this.initPromise.then((data) => data.settings.upstreamEnv || '');
  };

  getAIConnectionString = async () => {
    return this.initPromise.then((data) => data.settings.aiConnectionString);
  };
}

export const settingsApi = new SettingsApi();
